export default function getStylesheets({ themePath, theme }) {
    const stylesheets = [];

    if (theme === 'neutral') {
        stylesheets.push(`${themePath}/wallet-neutral.min.css`);
    }

    stylesheets.push(`${themePath}/wallet-style.min.css`);

    return stylesheets;
}
